import type { NodePropertyValue } from '../../../types/properties';

const defaults: Record<string, NodePropertyValue> = {
  mode: 'mfe',  // Default to Micro Frontend mode
  title: '',  // Chat window title (shown in MFE)
  subtitle: '',  // Subtitle below title
  chatName: 'My Chat',
  initialMessages: "Hi there! 👋\nMy name is Evie. How can I assist you today?",
  inputPlaceholder: "Type your question...",
  allowedOrigins: '*',
  authentication: 'none',
  apiKey: '',
  bearerToken: '',
  allowFileUploads: false,
  allowedFileMimeTypes: 'image/*,application/pdf,.doc,.docx,.txt',
  enableMetadata: false,
  webhookPath: '',
  requireButtonClick: false,
  loadPreviousSession: false,
  testInput: '{\n  "message": "Hello, this is a test message"\n}',
};

export default defaults;
